export type ConditionCategory =
  | 'Income'
  | 'Assets'
  | 'Property'
  | 'Credit'
  | 'Insurance'
  | 'Other'

export type ConditionStatus =
  | 'Pending'
  | 'In Progress'
  | 'Submitted'
  | 'Approved'
  | 'Waived'

export type ConditionPriority = 'high' | 'medium' | 'low'

export type SortField = 'title' | 'dueDate' | 'assignee' | 'priority'
export type SortDirection = 'asc' | 'desc'

export type Document = {
  id: string
  name: string
  type: string
  size: number
  uploadedAt: string
  uploadedBy: string
  url: string
}

export type Condition = {
  id: string
  title: string
  category: ConditionCategory
  status: ConditionStatus
  dueDate: string
  assignee: string
  notes: string
  priority: ConditionPriority
  documents: Document[]
}

export const STATUSES: ConditionStatus[] = [
  'Pending',
  'In Progress',
  'Submitted',
  'Approved',
  'Waived',
]

export const CATEGORIES: ConditionCategory[] = [
  'Income',
  'Assets',
  'Property',
  'Credit',
  'Insurance',
  'Other',
]

export const ASSIGNEES: string[] = ['John', 'Sarah', 'Mike', 'Lisa']

export const ASSIGNEE_COLORS: Record<string, string> = {
  John: 'bg-blue-500',
  Sarah: 'bg-purple-500',
  Mike: 'bg-emerald-500',
  Lisa: 'bg-amber-500',
}

export const CATEGORY_COLORS: Record<
  ConditionCategory,
  { bg: string; text: string; border: string }
> = {
  Income: {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    border: 'border-blue-200',
  },
  Assets: {
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
  },
  Property: {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    border: 'border-purple-200',
  },
  Credit: {
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-200',
  },
  Insurance: {
    bg: 'bg-teal-100',
    text: 'text-teal-700',
    border: 'border-teal-200',
  },
  Other: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    border: 'border-gray-200',
  },
}

export const STATUS_COLORS: Record<
  ConditionStatus,
  { bg: string; text: string; headerBg: string; chip: string; chipText: string }
> = {
  Pending: {
    bg: 'bg-slate-50',
    text: 'text-slate-600',
    headerBg: 'bg-slate-100',
    chip: 'bg-slate-100',
    chipText: 'text-slate-700',
  },
  'In Progress': {
    bg: 'bg-blue-50',
    text: 'text-blue-600',
    headerBg: 'bg-blue-100',
    chip: 'bg-blue-100',
    chipText: 'text-blue-700',
  },
  Submitted: {
    bg: 'bg-amber-50',
    text: 'text-amber-600',
    headerBg: 'bg-amber-100',
    chip: 'bg-amber-100',
    chipText: 'text-amber-700',
  },
  Approved: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-600',
    headerBg: 'bg-emerald-100',
    chip: 'bg-emerald-100',
    chipText: 'text-emerald-700',
  },
  Waived: {
    bg: 'bg-gray-50',
    text: 'text-gray-500',
    headerBg: 'bg-gray-100',
    chip: 'bg-gray-100',
    chipText: 'text-gray-600',
  },
}
